import Vue from 'vue'
export function hasBtn(btnName)
{
    if (btnName=='btn_add') {
        return true
    }
    var btn = sessionStorage.getItem('btnList') ? JSON.parse(sessionStorage.getItem('btnList')) : [];
    if (btn.length==0){
        return null
    }else {
        var link=[];
        btn.forEach(function(e,i) {
            link[i]=e.link;
        });
        return link.indexOf(btnName) > -1;
    }
}
export function removeByIndex(arr,index) {
    for(var i=0; i<arr.length; i++) {
        if(i == index) {
            arr.splice(i, 1);
            break;
        }
    }
}
export function api_imgurl(value) {
    var API_IMGURL = process.env.API_IMG_URL;
    return API_IMGURL+value;
}

export function getTime(/** timestamp=0 **/) {  
    const days = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    var ts = arguments[0] || 0;  
    var t,y,m,d,h,i,s;  
    t = ts ? new Date(ts*1000) : new Date();
    // t = getDate(parseInt(ts*1000));
    y = t.getFullYear();    //年
    m = t.getMonth()+1;    // 月
    d = t.getDate();    //日
    h = t.getHours();    //时
    i = t.getMinutes();    //分
    s = t.getSeconds();   //秒
    // 可根据需要在这里定义时间格式  
    if (arguments[1]=='y') {
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='m'){
        return (m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='d'){
        return (d<10?'0'+d:d); 
    }else if(arguments[1]=='yue'){
        return y+'-'+(m<10?'0'+m:m);
    }else if(arguments[1]=='hh:ii:ss'){
        return (h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);
    }else if(arguments[1]=='week'){
        return days[t.getDay()];
    }else if(arguments[1]=='yyyy'){
        return y+'';
    }else{
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)+' '+(h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);  
    }
}
export function IMG_URL(img) {
    if (img.indexOf('http')!=-1) {
        return img
    }else{
        return process.env.API_IMG_URL + img;
    }
}
export function IMG_URL_SHOW(img) {
    var img_array=img.split('.');
    var type_array=['jpg','jpeg','png','gif','bmp','JPG','JPEG','PNG','GIF','BMP'];
    var img_type=img_array[img_array.length-1];
    if (type_array.indexOf(img_type)!=-1) {
        if (img.indexOf('http')!=-1) {
            return img
        }else{
            return process.env.API_IMG_URL + img;
        }
    }else{
        return '/static/img/file.png'
    }
}

export function router_url(url, query) {
    var date = new Date().getTime();
    var query_obj = {
        t: date
    };
    if (query) {
        query['t'] = date;
    } else {
        query = query_obj
    }
    this.$router.push({
        path:url,
        query:query
    })
}
/**
 * 获取屏幕高度
 * @param {number} height 要减去的高度
 * @return {number}
 */
export function screenHeight(height = 0) {
    // header70   tag62 router_view30  form65  table_kuang20  button_kuang68   page66
    // var deduct=70+62+30+65+20+68+66;
    // header70   tag62 router_view30  form47  table_kuang0  button_kuang48   page46
    var deduct=70+62+30+47+0+48+46;
    var defaultHeight = 880
    var winHeight;
    if (window.innerHeight) {
        winHeight = window.innerHeight;
    } else if ((document.body) && (document.body.clientHeight)) {
        winHeight = document.body.clientHeight;
    }
    if (document.documentElement && document.documentElement.clientHeight) {
        winHeight = document.documentElement.clientHeight;
    }
    if (winHeight) {
        return winHeight - height - deduct
    } else {
        return defaultHeight - height - deduct
    }
}
export const formatRoutes = (aMenu,aRouter) => {
    aMenu.forEach(oMenu => {
        const {link, name, Menu,menu_type,sort } = oMenu
        if(Menu&&Menu.length>0){
            formatRoutes(Menu,aRouter);
        }
        if(link&&menu_type=='2'){
            var text = link.replace('_', '/');
            const oRouter = {
                path:link,
                name:name+link+sort,
                component:loadView(text),
            }
            aRouter.push(oRouter)
        }
    })
    return aRouter
}
export const loadView = (view) => {
    return resolve => require([`@/views/${view}`], resolve).catch(err => {})
}
/**
 * 是否外链
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:)/.test(path);
}

export function unique(array) {
    var res = [];
    for (var i = 0, arrayLen = array.length; i < arrayLen; i++) {
        for (var j = 0, resLen = res.length; j < resLen; j++ ) {
            if (array[i] === res[j]) {
                break;
            }
        }
        if (j === resLen) {
            res.push(array[i])
        }
    }
    return res;
}


// WEBPACK FOOTER //
// ./src/utils/index.js